// Chat input placeholder builder. Lives in a separate file from `ChatInput`
// and `ChatInputPlaceholder` so those component files only export components —
// `react-refresh/only-export-components` flags mixed exports.
//
// SC-2196: placeholder copy interpolates the active catalog's
// `entity_term_plural` so the example question matches the user's domain
// ("athletes" instead of "products"). Callers that don't have a catalog in
// scope use the `DEFAULT_CHAT_PLACEHOLDER` pre-resolved string.

export function defaultChatPlaceholder(plural: string): string {
  return `Try: How many ${plural} are missing descriptions?`;
}

/** Pre-resolved default for the "no catalog in scope" case. */
export const DEFAULT_CHAT_PLACEHOLDER = defaultChatPlaceholder('products');
